import client from '../clients/client';
import { ConversionChangeset, SizeConversionResponse } from '../models/size.conversion';

export const getSizeConversions = async (shopId: string): Promise<SizeConversionResponse> => {
  const response = await client.get<SizeConversionResponse>(`/size_conversion/${encodeURIComponent(shopId)}`);
  return response.data;
};

export const saveSizeConversions = async (
  shopId: string, changes: ConversionChangeset,
): Promise<SizeConversionResponse> => {
  const response = await client.post<SizeConversionResponse>(`/size_conversion/${encodeURIComponent(shopId)}`, changes);
  return response.data;
};